<template>
	<Row class="clearfix"
	    :class="prefixCls">
		<Col span="8">
		<slot></slot>
		</Col>
		<Page v-bind="$attrs"
		    :show-sizer="showSizer"
		    :show-elevator="showElevator"
		    :show-total="showTotal"
		    :size="size"
		    :total="total"
		    :current="pageNo"
		    :page-size="pageSize"
		    :class="prefixCls + '-page'"
		    @on-page-size-change="onPageSizeChange"
		    @update:current="onCurrentChange">
		</Page>
	</Row>
</template>
<script>
import Page from '../page'
import Row from '../row'
import Col from '../col'
import { currency, debounce } from '../../utils/assist'

export default {
	inheritAttrs: false,
	components: {
		Row,
		Col,
		Page
	},

	props: {
		total: {
			type: Number,
			default: 0
		},
		pageNo: {
			type: Number,
			default: 1
		},
		pageSize: {
			type: Number,
			default: 20
		},
		pagerClass: {
			type: String,
			default: ''
		},
		size: {
			type: String,
			default: "small"
		},
		showSizer: {
			type: Boolean,
			default: true
		},
		showElevator: {
			type: Boolean,
			default: true
		},
		showTotal: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {}
	},

	computed: {
		prefixCls() {
			return "ivu-table-pager"
		}
	},

	methods: {
		onPageSizeChange(size) {
			this.$emit("update:pageSize", size)
			this.change()
		},

		onCurrentChange(current) {
			this.$emit("update:pageNo", current)
			this.change()
		},

		change: debounce(10, function() {
			this.$emit("change", { pageNo: this.pageNo, pageSize: this.pageSize })
		})
	},
}
</script>